import axios from 'axios'
import utils from './utils'
// 请求拦截器
axios.interceptors.request.use(
  config => {
    // const userToken = utils.getToken() || '07c58da24be34ae0ba5ebf3e3786315a' //  07c58da24be34ae0ba5ebf3e3786315a
    /* 设置请求头部 */
    config.headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
      // 'user-token': userToken,
    }
    config.headers['api-sign'] = utils.getAccessTokenParams(config.url, config.params, utils.getToken())
    console.log('config:', config)
    return config
  },
  error => {
    return Promise.error(error)
  }
)

// 添加响应拦截器<==>响应回来后做的事
axios.interceptors.response.use((response) => {
  setTimeout(() => {
  }, 200)
  console.log('响应拦截器', response.data)
  const responseData = response.data
  // 外部h5无需判断是否登录
  // if (responseData.code !== 100000 && responseData.code !== 200008) {
  //   if (responseData.code === 200005 || responseData.code === 200001) {
  //     console.log('调用App登录')
  //     utils.gotoLogin()
  //     return
  //   }
  //   alert(responseData.msg)
  //   return
  // }
  return responseData
}, function (err) {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求错误'
        break

      case 401:
        err.message = '未授权，请登录'
        break

      case 403:
        err.message = '拒绝访问'
        break

      case 404:
        err.message = `请求地址出错: ${err.response.config.url}`
        break

      case 408:
        err.message = '请求超时'
        break

      case 500:
        err.message = '服务器内部错误'
        break

      case 501:
        err.message = '服务未实现'
        break

      case 502:
        err.message = '网关错误'
        break

      case 503:
        err.message = '服务不可用'
        break

      case 504:
        err.message = '网关超时'
        break

      case 505:
        err.message = 'HTTP版本不受支持'
        break

      default:
    }
  }
  return Promise.reject(err)
})
